import {Navigate, NonIndexRouteObject} from "react-router"
import {VdaApp} from "../components/app/VdaApp";
import {ErrorPage} from "../components/page";
import {
    navigationStore,
    pageQueryStore,
    validationStore,
    vdaCreateStore,
    vdaCustomerStore,
    vdaDetailStore,
    vdaOverviewStore
} from "../store";
import {VehicleDataAcquisitionSortByDto, VehicleDataAcquisitionStatusDto} from "../api/vda";
import {SortTypeDto} from "../api/fms";
import React from "react";


const vda: NonIndexRouteObject[] = [
    {
        path: `/vda`,
        element: <VdaApp mode={'overview'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            await vdaCustomerStore.init()
            const searchParams = new URL(request.url).searchParams
            pageQueryStore.updateSystem('vda', searchParams)

            vdaOverviewStore.page = parseInt(searchParams.get("page") || "") || 1
            vdaOverviewStore.size = parseInt(searchParams.get("size") || "") || 25

            vdaOverviewStore.sortBy = searchParams.get('sortBy') as VehicleDataAcquisitionSortByDto || undefined
            vdaOverviewStore.sortType = searchParams.get('sortType') as SortTypeDto || undefined
            vdaOverviewStore.query = searchParams.get('q') || undefined
            vdaOverviewStore.fromRelative = searchParams.get('fromRelative') || undefined
            vdaOverviewStore.toRelative = searchParams.get('toRelative') || undefined
            vdaOverviewStore.fromAbsolute = searchParams.get('fromAbsolute') || undefined
            vdaOverviewStore.toAbsolute = searchParams.get('toAbsolute') || undefined
            vdaOverviewStore.customerId = searchParams.get('customerId') || undefined
            vdaOverviewStore.status = searchParams.getAll('status') as VehicleDataAcquisitionStatusDto[] || undefined

            vdaOverviewStore.load().finally()
            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/vda/create`,
        element: <VdaApp mode={'create'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            validationStore.reset()
            vdaCreateStore.reset()
            await vdaCustomerStore.init()
            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/vda/:id`,
        element: <VdaApp mode={'detail'}/>,
        errorElement: <Navigate to={`/vda`} replace={true}/>,
        loader: async ({params, request}) => {
            validationStore.reset()
            vdaDetailStore.id = params.id!!
            await vdaCustomerStore.init()
            const result = await vdaDetailStore.load()
            if (!result) {
                throw Error
            }
            navigationStore.setActivePath(request)
            return null
        }
    },
]

export {
    vda
}
